import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, BadgeCheck, CalendarDays, MapPin, QrCode } from "lucide-react";
import { API, api, formatDate } from "@/lib/api";
import { Shell } from "@/components/layout/Shell";

export default function TicketPage() {
  const { code } = useParams();
  const [t, setT] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api(`/public/ticket/${code}`).then(setT).catch(e => setErr(e.message)); }, [code]);

  return (
    <Shell>
      <main className="inner-page">
        <div className="container ticket-wrap">
          <Link to="/events" className="text-link" data-testid="ticket-back"><ArrowLeft size={14} /> All events</Link>
          {err && <div className="error-message" data-testid="ticket-error">{err}</div>}
          {t && (
            <article className={t.checked_in_at ? "ticket attended" : "ticket"} data-testid="ticket-card">
              <div className="ticket-main">
                <span className="eyebrow">Event ticket</span>
                <h1>{t.event?.title || t.event_title}</h1>
                <div className="event-row-facts">
                  <span><CalendarDays size={14} /> {formatDate(t.event?.date || t.event_date)}</span>
                  {t.event?.venue && <span><MapPin size={14} /> {t.event.venue}</span>}
                </div>
                <div className="ticket-holder">
                  <span>Attendee</span>
                  <strong data-testid="ticket-name">{t.name}</strong>
                  <small>Ref {t.id}</small>
                </div>
                <div className={`pill ${t.checked_in_at ? "paid" : ""}`} data-testid="ticket-status">
                  {t.checked_in_at ? <><BadgeCheck size={12} /> Checked in · {formatDate(t.checked_in_at)}</> : "Not yet checked in"}
                </div>
              </div>
              <div className="ticket-qr">
                <img src={`${API}/public/ticket/${code}/qr.png`} alt="Check-in QR code" data-testid="ticket-qr" />
                <code data-testid="ticket-code">{code}</code>
                <p><QrCode size={13} /> Show this code at the door</p>
              </div>
            </article>
          )}
        </div>
      </main>
    </Shell>
  );
}
